import { render, staticRenderFns } from "./RUDataSection.vue?vue&type=template&id=a14c28be&scoped=true"
import script from "./RUDataSection.vue?vue&type=script&lang=js"
export * from "./RUDataSection.vue?vue&type=script&lang=js"
import style0 from "./RUDataSection.vue?vue&type=style&index=0&id=a14c28be&prod&scoped=true&lang=css"
import style1 from "./RUDataSection.vue?vue&type=style&index=1&id=a14c28be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14c28be",
  null
  
)

export default component.exports